import React, { ComponentType } from 'react';
import { LayoutProps, Resolve } from '@jsonforms/core';
import get from 'lodash/get';
import find from 'lodash/find';
import {
  JsonFormsStateContext,
  JsonFormsDispatch,
  withJsonFormsContext,
} from '@jsonforms/react';

interface ArrayRendererProps extends LayoutProps {
  index: number;
  childLabelProp?: string;
  childLabel: string;
}

export const ArrayRenderer = (props: ArrayRendererProps) => {
  const { uischema, schema, path, renderers, cells, childLabel } = props;
  const elements = uischema.options?.detail.elements;
  const itemsToRender = elements?.map((element: any, index: number) => {
    return (
      <JsonFormsDispatch
        schema={schema}
        uischema={element}
        path={path}
        enabled
        renderers={renderers}
        cells={cells}
        key={index}
      />
    );
  });
  return (
    <>
      <h6
        style={{
          marginBottom: 0,
          marginTop: 25,
          color: 'rgb(104, 100, 100)',
          fontWeight: 'bold',
          fontSize: 'inherit',
        }}
      >
        {childLabel}
      </h6>
      {itemsToRender}
    </>
  );
};

const getFirstPrimitiveProp = (schema: any) => {
  if (schema?.properties) {
    return find(Object.keys(schema.properties), propName => {
      const prop = schema.properties[propName];
      return (
        prop.type === 'string' ||
        prop.type === 'number' ||
        prop.type === 'integer'
      );
    });
  }
  return undefined;
};

const withContextToArrayRenderd =
  (
    Component: ComponentType<ArrayRendererProps>,
  ): ComponentType<ArrayRendererProps> =>
  ({ ctx, props }: JsonFormsStateContext & ArrayRendererProps) => {
    const { childLabelProp, schema, path } = props;
    const childData = Resolve.data(ctx.core.data, path);

    const firstPrimitiveProp = !childLabelProp
      ? getFirstPrimitiveProp(schema)
      : '';
    const childLabel: any = childLabelProp
      ? get(childData, childLabelProp, '')
      : firstPrimitiveProp;
    return <Component {...props} childLabel={childLabel} />;
  };

const withCustomProps = (Component: ComponentType<ArrayRendererProps>) => {
  return withJsonFormsContext(withContextToArrayRenderd(React.memo(Component)));
};

export default withCustomProps(ArrayRenderer);
